export default __webpack_public_path__ + "static/media/attractions6.c6a7125b.png";